//import React, { useEffect } from "react";
//import moment from "moment";
import { X } from "lucide-react";

const SuccessNotification = ({
  executionStatus,
  showNotification,
  onClose,
}) => {
  // useEffect(() => {
  //   if (
  //     executionStatus?.submissionResults?.status === "Accepted" &&
  //     showNotification
  //   ) {
  //     const timer = setTimeout(onClose, 10000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [executionStatus?.submissionResults?.status, showNotification, onClose]);

  if (
    !showNotification ||
    executionStatus?.submissionResults?.status !== "Accepted"
  ) {
    return null;
  }

  const {
    pointsEarned,
    attemptCounter,
    firstSubmitionDate,
    lastSubmissionDate,
  } = executionStatus?.submissionResults ?? {};

  return (
    <>
      <style jsx="true">{`
        @import url("https://fonts.googleapis.com/css2?family=Creepster&family=Eater&display=swap");

        .success-notification-wrapper {
          position: fixed;
          bottom: 5rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 50;
          animation: spookyRise 0.6s ease-out;
        }

        @keyframes spookyRise {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(100px) scale(0.8);
          }
          60% {
            transform: translateX(-50%) translateY(-10px) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }

        .success-card {
          position: relative;
          background: linear-gradient(
            145deg,
            rgba(10, 10, 10, 0.95),
            rgba(45, 27, 105, 0.95)
          );
          border: 3px solid #39ff14;
          border-radius: 20px;
          padding: 2rem 2.5rem;
          box-shadow: 0 0 40px rgba(57, 255, 20, 0.5),
            0 10px 50px rgba(0, 0, 0, 0.8),
            inset 0 0 30px rgba(57, 255, 20, 0.1);
          min-width: 400px;
          max-width: 500px;
          backdrop-filter: blur(10px);
          overflow: hidden;
        }

        .success-card::before {
          content: "";
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(
            circle,
            rgba(57, 255, 20, 0.1) 0%,
            transparent 70%
          );
          animation: pulseGlow 3s ease-in-out infinite;
          pointer-events: none;
        }

        @keyframes pulseGlow {
          0%,
          100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
        }

        .success-card::after {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(57, 255, 20, 0.3),
            transparent
          );
          animation: shimmer 2s ease-in-out infinite;
        }

        @keyframes shimmer {
          0% {
            left: -100%;
          }
          100% {
            left: 200%;
          }
        }

        .close-button {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
          padding: 0.5rem;
          background: rgba(255, 69, 0, 0.2);
          border: 1px solid #ff4500;
          border-radius: 50%;
          color: #ff4500;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
        }

        .close-button:hover {
          background: rgba(255, 69, 0, 0.4);
          transform: rotate(90deg) scale(1.1);
          box-shadow: 0 0 15px rgba(255, 69, 0, 0.6);
        }

        .success-content {
          position: relative;
          z-index: 5;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }

        .success-title {
          font-family: "Creepster", cursive;
          font-size: 2rem;
          color: #39ff14;
          text-shadow: 0 0 20px #39ff14, 0 0 40px #39ff14, 2px 2px 0 #0a0a0a;
          letter-spacing: 3px;
          margin-bottom: 0.5rem;
          animation: flicker 2s infinite;
        }

        @keyframes flicker {
          0%,
          100% {
            opacity: 1;
          }
          45%,
          47% {
            opacity: 0.9;
          }
          49% {
            opacity: 0.95;
          }
        }

        .success-emoji {
          font-size: 3rem;
          animation: float 2s ease-in-out infinite, spin 4s linear infinite;
          filter: drop-shadow(0 0 20px #39ff14);
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-10px) rotate(180deg);
          }
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .points-display {
          font-family: "Eater", cursive;
          font-size: 1.3rem;
          color: #ffd700;
          text-shadow: 0 0 10px #ffd700, 0 0 20px #ff4500;
          font-weight: bold;
          padding: 0.5rem 1.5rem;
          background: rgba(255, 69, 0, 0.2);
          border: 2px solid #ff4500;
          border-radius: 15px;
          animation: pointsPulse 1s ease-in-out infinite;
        }

        @keyframes pointsPulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        .stats-container {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          width: 100%;
          margin-top: 0.5rem;
        }

        .stat-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.5rem 1rem;
          background: rgba(10, 10, 10, 0.6);
          border: 1px solid rgba(57, 255, 20, 0.3);
          border-radius: 10px;
          font-size: 0.7rem;
          color: #c0c5ce;
          transition: all 0.3s ease;
        }

        .stat-row:hover {
          background: rgba(10, 10, 10, 0.8);
          border-color: #39ff14;
          transform: translateX(5px);
        }

        .stat-label {
          font-family: "Eater", cursive;
          color: #39ff14;
          font-weight: 600;
          letter-spacing: 1px;
        }

        .stat-value {
          font-family: monospace;
          color: #f8f8e8;
          text-shadow: 0 0 5px rgba(57, 255, 20, 0.3);
        }

        .skull-decoration {
          position: absolute;
          opacity: 0.1;
          pointer-events: none;
          animation: floatSlow 6s ease-in-out infinite;
        }

        .skull-decoration.left {
          left: -20px;
          top: 20%;
          font-size: 4rem;
          animation-delay: 0s;
        }

        .skull-decoration.right {
          right: -20px;
          bottom: 20%;
          font-size: 4rem;
          animation-delay: 3s;
        }

        @keyframes floatSlow {
          0%,
          100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(10deg);
          }
        }

        @media (max-width: 640px) {
          .success-card {
            min-width: 320px;
            max-width: 90vw;
            padding: 1.5rem;
          }

          .success-title {
            font-size: 1.5rem;
          }

          .success-emoji {
            font-size: 0.5rem;
          }

          .points-display {
            font-size: 0.5rem;
          }

          .stat-row {
            font-size: 0.8rem;
            padding: 0.4rem 0.8rem;
          }
        }
      `}</style>

      <div className="success-notification-wrapper">
        <div className="success-card">
          {/* Decorative skulls */}
          <div className="skull-decoration left">💀</div>
          <div className="skull-decoration right">💀</div>

          {/* Close button */}
          <button
            onClick={onClose}
            className="close-button"
            aria-label="Close notification"
          >
            <X size={18} />
          </button>

          <div className="success-content">
            {/* Animated success emoji */}
            <div className="success-emoji">🎃</div>

            {/* Title */}
            <h3 className="success-title">RITUAL COMPLETE!</h3>

            {/* Points display */}
            {pointsEarned && (
              <div className="points-display">
                +{pointsEarned} SOULS CAPTURED
              </div>
            )}

            {/* Stats */}
            <div className="stats-container">
              {/* <div className="stat-row">
                <span className="stat-label">⚡ Attempts</span>
                <span className="stat-value">{attemptCounter}</span>
              </div> */}
              {/* <div className="stat-row">
                <span className="stat-label">🕰️ First Summoning</span>
                <span className="stat-value">
                  {moment
                    .utc(firstSubmitionDate)
                    .local()
                    .format("MMM D, h:mm A")}
                </span>
              </div>
              <div className="stat-row">
                <span className="stat-label">🔮 Last Summoning</span>
                <span className="stat-value">
                  {moment
                    .utc(lastSubmissionDate)
                    .local()
                    .format("MMM D, h:mm A")}
                </span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessNotification;
